import logo from "./logo.svg";
import "./App.css";
import React, { useEffect, useRef, useState } from "react";
import { select, csvParse, csv, autoType, scaleBand, scaleLinear, max, color, scaleOrdinal, axisLeft, axisBottom } from "d3";
// import data1 from "./try1.csv";
import data1 from "./try2.csv";

function App() {
    const svgRef = useRef();
    const svgRef1 = useRef();
    var keys1 = ["2018", "2019", "2020", "2021"];
    const [keys, setKeys] = useState(keys1);
    const [target, setTarget] = useState("US");
    const [high, setHigh] = useState(undefined);
    var data, groupKey;
    var margin = { top: 10, right: 10, bottom: 20, left: 40 };
    var height = 500;
    var width = 1000;
    var countries = ["US", "Canada", "Mexico", "Germany", "UK", "France", "Rest of Europe", "China", "Japan", "India", "Rest of Asia-Pacific", "Middle East & Africa", "Latin America", ""];
    var segments = ["Service Type", "Application", "Software"];
    var subsegments = [
        ["Professional Services", "Managed Services"],
        ["Commercial", "Industrial", "Residential"],
        [
            "Security Management",
            "Facility Management",
            "Infrastructure Management",
            "Energy Management",
            "Emergency Management",
            "Security Management",
            "Facility Management",
            "Infrastructure Management",
            "Energy Management",
            "Emergency Management",
        ],
    ];

    var countryLoad = [];
    // console.log("asdadassa");
    const [seg, setseg] = useState("Service Type");
    useEffect(() => {
        const svg = select(svgRef.current);
        const svg1 = select(svgRef1.current);
        svg1.attr("width", width).attr("height", height);
        countries.map((value, index) => {
            countryLoad.push([]);
        });

        csv(data1, autoType).then((value) => {
            // console.log(value);
            data = value;
            // groupKey = data.columns[0];
            // console.log(groupKey);
            // keys = data.columns.slice(1);
            // console.log(keys);
            var obj = [],
                objc = [];
            var obj1 = [];
            data.map((vals) => {
                // console.log(vals.Segment);
                (obj1[segments.indexOf(vals.Segment)] || (obj1[segments.indexOf(vals.Segment)] = [])).push(vals);
                // (obj[countries.indexOf(vals.Country)] || (obj[countries.indexOf(vals.Country)] = [])).push(vals);
            });
            // console.log(obj1);
            // var obj1 = [];

            obj1.map((va, ind) => {
                var tr = [];
                va.map((vall, index) => {
                    // console.log(vall);
                    (tr[countries.indexOf(vall.Country)] || (tr[countries.indexOf(vall.Country)] = [])).push(vall);
                });
                // console.log(tr);
                var arr = [];
                tr.map((valt, index) => {
                    // var ar = [];
                    var com = {};
                    var hm = 0,
                        ht = 0,
                        hu = 0,
                        ho = 0,
                        hi;
                    valt.map((vat, ind) => {
                        hm += vat["2018"];
                        ht += vat["2019"];
                        hu += vat["2020"];
                        ho += vat["2021"];
                        hi = vat["Country"];
                        // com["2018"] += hm;
                        // console.log(vat["2018"]);
                    });
                    com["2018"] = hm;
                    com["2019"] = ht;
                    com["2020"] = hu;
                    com["2021"] = ho;
                    com["Country"] = hi;
                    arr.push(com);
                });
                objc.push(tr);
                obj.push(arr);
            });

            // console.log(obj, objc);
            var final = obj[segments.indexOf(seg)];

            var groupKey = "Country";

            const x0 = scaleBand()
                .domain(
                    final.map((d) => {
                        // console.log(d[groupKey]);
                        return d[groupKey];
                    })
                )
                .rangeRound([margin.left, width - margin.right])
                .paddingInner(0.1);

            const x1 = scaleBand().domain(keys).rangeRound([0, x0.bandwidth()]).padding(0.05);
            const y = scaleLinear()
                .domain([0, max(final, (d) => max(keys, (key) => d[key]))])
                .nice()
                .rangeRound([height - margin.bottom, margin.top]);

            const color = scaleOrdinal().domain(keys1).range(["#0021c7", "#40bedd", "#007a99", "#5a1de7"]);
            const xAxis = (g) =>
                g
                    .attr("transform", `translate(0,${height - margin.bottom})`)
                    .call(axisBottom(x0).tickSizeOuter(0))
                    .call((g) => g.select(".domain").remove());
            const yAxis = (g) =>
                g
                    .attr("transform", `translate(${margin.left},0)`)
                    .call(axisLeft(y).ticks(null, "s"))
                    .call((g) => g.select(".domain").remove())
                    .call((g) => g.select(".tick:last-of-type text").clone().attr("x", 3).attr("text-anchor", "start").attr("font-weight", "bold").text("final.y"));

            svg.attr("width", width)
                .attr("height", height)
                .selectAll(".bar")
                .data(final)
                .join("g")

                .attr("class", "bar")

                .on("click", (d) => handleHighlight(d))

                .attr("transform", (d) => `translate(${x0(d[groupKey])},0)`)

                .selectAll("rect")
                .data((d) => keys.map((key) => ({ key, value: d[key] })))

                .join("rect")
                .attr("x", (d) => x1(d.key))
                .attr("y", (d) => y(d.value))
                .attr("width", x1.bandwidth())
                .attr("height", (d) => y(0) - y(d.value))
                .attr("fill", (d) => color(d.key));

            var handleHighlight = (d) => {
                if (high) {
                    select(high).style("outline", "none").style("outline-offset", "none");
                    select(d.srcElement.parentElement).style("outline", "1px dashed black").style("outline-offset", "7px");
                    setHigh(d.srcElement.parentElement);
                } else {
                    setHigh(d.srcElement.parentElement);
                    select(d.srcElement.parentElement).style("outline", "1px dashed black").style("outline-offset", "7px");
                }
                setTarget(d.path[1].__data__.Country);
            };

            // svg.on("click", (d) => console.log(d));
            svg.select(".x-axis").call(xAxis);
            // path[1].__data__.Country
            svg.select(".y-axis").call(yAxis);

            var handleClick = (target) => {
                var groupKey1 = "Sub-Segment";
                // console.log(target);
                var final1 = objc[segments.indexOf(seg)][countries.indexOf(target)];
                // console.log(final1);
                const y0 = scaleBand()
                    .domain(final1.map((d) => d[groupKey1]))
                    .rangeRound([margin.top, height - margin.bottom])
                    .paddingInner(0.1);
                const y1 = scaleBand().domain(keys).rangeRound([0, y0.bandwidth()]).padding(0.05);
                const x = scaleLinear()
                    .domain([0, max(final1, (d) => max(keys, (key) => d[key]))])
                    .nice()
                    .rangeRound([140, 1000 - margin.right]);
                const xAxis1 = (g) =>
                    g
                        .attr("transform", `translate(0,${height - margin.bottom})`)
                        .call(axisBottom(x).tickSizeOuter(0))
                        .call((g) => g.select(".domain").remove())
                        .call(axisBottom(x).ticks(null, "s"));
                // .call((g) => g.select(".tick:last-of-type text").clone().attr("x", 15).attr("text-anchor", "start").attr("font-weight", "bold").text("data.y"));

                const yAxis1 = (g) =>
                    g
                        .attr("transform", `translate(${130},0)`)
                        .call(axisLeft(y0).ticks(null, "s"))
                        .call((g) => g.select(".domain").remove());

                svg1.selectAll(".bar")
                    .data(final1)
                    .join("g")
                    .attr("class", "bar")
                    .attr("transform", (d) => `translate(0,${y0(d[groupKey1])})`)
                    .selectAll("rect")
                    .data((d) => keys.map((key) => ({ key, value: d[key] })))
                    .join("rect")
                    .attr("x", (d) => x(0))
                    .attr("y", (d) => y1(d.key))
                    .attr("height", y1.bandwidth())
                    .attr("width", (d) => x(d.value) - x(0))
                    .attr("fill", (d) => color(d.key));
                svg1.select(".x-axis1").call(xAxis1);
                // path[1].__data__.Country
                svg1.select(".y-axis1").call(yAxis1);
            };
            handleClick(target);
        });
    }, [data, keys, seg, target, high]);

    return (
        <div className="innerBody">
            {" "}
            <div className="fieldsWrap">
                <div className="fields">
                    {keys1.map((key) => (
                        <div key={key} className="field">
                            <input
                                id={key}
                                type="checkbox"
                                checked={keys.includes(key)}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setKeys(Array.from(new Set([...keys, key])).sort());
                                    } else {
                                        setKeys(keys.filter((_key) => _key !== key).sort());
                                    }
                                }}
                            />
                            <label htmlFor={key}>{key}</label>
                        </div>
                    ))}
                </div>
                <div className="fields">
                    {segments.map((key1) => (
                        <div key={key1} className="field">
                            <input
                                id={key1}
                                type="radio"
                                value={key1}
                                name="segmentType"
                                checked={seg === key1}
                                onClick={(e) => {
                                    setseg(e.target.value);
                                }}
                            />
                            <label htmlFor={key1}>{key1}</label>
                        </div>
                    ))}
                </div>
            </div>
            <svg ref={svgRef}>
                <g className="x-axis" />
                <g className="y-axis" />
            </svg>
            <p className="heading">{target}</p>
            <svg ref={svgRef1} className="try">
                <g className="y-axis1" />
                <g className="x-axis1" />
            </svg>
        </div>
    );
}

export default App;
